import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ModalShow } from '@shared/modal/modal.actions';
import { ModalButtonType } from '@shared/modal/modal.component';
import { isModalCancelled, isModalConfirmed } from '@shared/modal/modal.reducer';
import { isTruthy } from '@shared/utils';

import { Note } from 'mojo-irp-notes';

@Component({
  selector: 'mojo-notes-options',
  templateUrl: './notes-options.component.html',
  styleUrls: ['./notes-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotesOptionsComponent {
  @Input()
  note: Note;

  @Output()
  deleteNoteClicked = new EventEmitter();

  @Output()
  editNoteClicked = new EventEmitter();

  isConfirmed$ = this.store.pipe(select(isModalConfirmed), filter(isTruthy));
  isCancelled$ = this.store.pipe(select(isModalCancelled), filter(isTruthy));

  confirmSubscription: Subscription;
  cancelSubscription: Subscription;

  constructor(private store: Store<{}>) {}

  editNote() {
    this.editNoteClicked.emit();
  }

  deleteNote() {
    this.store.dispatch(
      new ModalShow({
        title: 'Delete note',
        subTitle: 'Do you really want to delete this note? This action can not be undone.',
        confirmText: 'Delete',
        buttonType: ModalButtonType.danger,
      }),
    );
    this.confirmSubscription = this.isConfirmed$.subscribe(() => {
      this.unsubscribe();
      this.deleteNoteClicked.emit();
    });
    this.cancelSubscription = this.isCancelled$.subscribe(() => {
      this.unsubscribe();
    });
  }

  unsubscribe() {
    if (!!this.confirmSubscription) {
      this.confirmSubscription.unsubscribe();
    }
    if (!!this.cancelSubscription) {
      this.cancelSubscription.unsubscribe();
    }
  }
}
